import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';

@Component({
    selector: 'app-settings-table-name-dialog',
    templateUrl: './settings.table.name.dialog.component.html',
    styleUrls: ['./settings.table.name.dialog.component.css'],
})
export class SettingsTableNameDialogComponent implements OnInit {
    /**
     * Объект формы
     */
    form: FormGroup;

    /**
     * Ссылка на объект формы
     */
    @ViewChild('formRef', { static: true }) formRef: ElementRef;

    /**
     * Конструктор
     * @param fb создатель форм
     * @param appService сервис взаимодействия с внешними ресурсами
     * @param dialogRef ссылка на диалог
     * @param data данные для диалога
     */
    constructor(
        private fb: FormBuilder,
        public appService: AppService,
        public dialogRef: MatDialogRef<SettingsTableNameDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            name: string;
            type: string;
        },
    ) {}

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        this.form = this.fb.group({
            name: [this.data.name, [Validators.required]],
        });
    }

    /**
     * Сохранение данных
     */
    save() {
        if (this.form.valid) {
            let name = this.form.value.name;

            switch (typeof name) {
                case 'string':
                    name = name.trim();
                    break;
            }

            this.dialogRef.close({
                save: true,
                name,
            });
        } else {
            AppHelper.validateAllFormFields(this.form);
            const target = this.formRef.nativeElement.querySelector(
                '.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid',
            );
            setTimeout(() => {
                if (target.querySelector('input')) {
                    target.querySelector('input').focus();
                }
            }, 0);
        }
    }

    /**
     * Закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }
}
